import React from "react";
import OtpInput from "react-otp-input";
import styles from "./AuthBySmsOtpInput.module.scss";
import classNames from "classnames/bind";
const cx = classNames.bind(styles);

type OtpInputType = {
  otp: string;
  setOtp: (value: string) => void;
  isValid: boolean;
};

const AuthBySmsOtpInput = ({ otp, setOtp, isValid }: OtpInputType) => {
  return (
    <OtpInput
      value={otp}
      onChange={(value) => setOtp(value)}
      numInputs={4}
      inputType={"number"}
      shouldAutoFocus={true}
      renderSeparator={<span>-</span>}
      containerStyle={cx("container")}
      inputStyle={cx("input", { invalid: !isValid })}
      renderInput={(props) => <input pattern="[0-9]*" {...props} />}
    />
  );
};

export { AuthBySmsOtpInput };
